import { InjectionToken } from '@angular/core';
import { ExpyChatSidebar } from '@wk/fab-expy-sdk';

export const EXPY_SIDEBAR_CLASS = new InjectionToken<typeof ExpyChatSidebar>(
  'EXPY_SIDEBAR_CLASS'
);
